import React, { memo } from 'react';

const AirportDropdown = props => {
    let input = document.getElementById(props.inputId);
    /*
        we need to know if the current value it's similar to the other one, 
        or if the current value exist in the list
    */
    let airportWithTheSameInputValue = (input && input.value) ?
        airport => (airport === String(input.value).toUpperCase()) :
        () => { };
    let gotAnAirportMatch = props.corresponding.find(airportWithTheSameInputValue);
    /** if the current value is valid, just click on the btn */
    if ((typeof gotAnAirportMatch !== "undefined") && gotAnAirportMatch !== props.exclude) {
        props.onSelect(gotAnAirportMatch);
        return null;
    }
    /** show the dropdown if we got the user focus */
    return ((props.show && props.corresponding.length > 0)
        && (document.activeElement === document.getElementById(props.inputId))) ?
        <ul className="AirportDropdown text-left">
            {
                props.corresponding.map((airport, index) => {
                    const onClickEvent = () => {
                        document.getElementById(props.inputId).value = airport;
                        props.onSelect(airport);
                    }
                    return <button
                        disabled={(airport === props.exclude)}
                        onClick={() => onClickEvent()}
                        key={index}
                        type="button"
                        className="list-group-item list-group-item-action">
                        {airport}
                    </button>
                })
            }
        </ul> : null;
}
export default memo(AirportDropdown);